import { render, staticRenderFns } from "./PopupRiskInfoEp3.vue?vue&type=template&id=647807c7&scoped=true"
import script from "./PopupRiskInfoEp3.vue?vue&type=script&lang=js"
export * from "./PopupRiskInfoEp3.vue?vue&type=script&lang=js"
import style0 from "./PopupRiskInfoEp3.vue?vue&type=style&index=0&id=647807c7&prod&lang=scss&scoped=true"
import style1 from "./PopupRiskInfoEp3.vue?vue&type=style&index=1&id=647807c7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647807c7",
  null
  
)

export default component.exports